<template>
  <div>
    <UnitLoading v-if="isLoadingGeneralMsgs" class="my-5" />
    <UnitEmpty v-if="isEmptyGeneralMsgs" class="my-5" />
    <div
      v-for="(gm, index) in generalMsgs.data.data.data"
      :key="gm.id"
      class="px-2 py-3 border-bottom"
      :class="{ 'border-top mt-2': index === 0 }"
    >
      <div class="font-weight-bolder text-primary">
        {{ formatNameUser(gm.message.teacher) }}
      </div>
      <small class="text-muted">
        {{ gm.created_at | formatDateTime }}
      </small>
      <div class="mt-1">
        {{ gm.message.text }}
      </div>
      <div class="text-center">
        <b-btn
          v-if="!Boolean(gm.seen)"
          pill
          @click="onSeenMsg(gm.id)"
          variant="primary"
          class="text-center"
          :disabled="allBtnDisabled"
        >
          <span class="mx-3"> Lu </span>
          <b-spinner
            class="text-secondary"
            small
            v-if="buttonsLoading[gm.id]"
          />
        </b-btn>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @file       Comment general message component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import UnitEmpty from "@/modules/comments/components/unitEmpty.vue";
import UnitLoading from "@/modules/comments/components/unitLoading.vue";
import { commentsMixin } from "@/modules/comments/mixins.js";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "UnitGeneralMessage",
  mixins: [commentsMixin],
  components: { UnitEmpty, UnitLoading },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      buttonsLoading: [],
      allBtnDisabled: false,
      init: true
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Check if empty general messages.
     * 
     * @return   {Bool}   true or false
     */
    isEmptyGeneralMsgs() {
      return (
        this.generalMsgs.status === "success" &&
        !this.generalMsgs.data.data.data.length
      );
    },

    /**
     * Check if loading general messages.
     * 
     * @return   {Bool}   true or false
     */
    isLoadingGeneralMsgs() {
      return this.generalMsgs.status === "fetching" && this.init;
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Message seen.
     * 
     * @param   {int}   msgId       The message ID
     */
    onSeenMsg(msgId) {
      Vue.set(this.buttonsLoading, msgId, true);
      this.allBtnDisabled = true;
      this.$store
        .dispatch("comments/putGeneralMsg", {
          student_has_message: msgId,
          seen: 1
        })
        .then(() => {
          this.$store.dispatch("comments/getGeneralMsgs").then(() => {
            Vue.set(this.buttonsLoading, msgId, false);
            this.allBtnDisabled = false;
            if (!this.generalMsgs.data.data.data.length) {
              this.callJobs();
              this.$bvModal.hide("generalMessageModal");
            }
          });
        })
        .catch(() => {
          Vue.set(this.buttonsLoading, msgId, false);
          this.allBtnDisabled = false;
        });
    }
  },
  watch: {
    isLoadingGeneralMsgs: {
      handler: function() {
        if (this.init) {
          this.init = !this.init;
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped></style>
